export default __webpack_public_path__ + "static/media/Birthday-announcement-right-bg.4d89ab47.png";